import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
import { OptionContent } from "../OptionContent";
var cn = classNames.bind(style);
export var DropdownOption = /*#__PURE__*/memo(function (_ref) {
  var label = _ref.label,
    iconSrc = _ref.iconSrc,
    onClick = _ref.onClick,
    active = _ref.active,
    href = _ref.href,
    _ref$extraLinkAttribu = _ref.extraLinkAttributes,
    extraLinkAttributes = _ref$extraLinkAttribu === void 0 ? {} : _ref$extraLinkAttribu,
    color = _ref.color,
    cardNumber = _ref.cardNumber,
    additionalInfo = _ref.additionalInfo,
    options = _ref.options;
  var Tag = useMemo(function () {
    return href ? 'a' : 'button';
  }, [href]);
  var linkAttributes = useMemo(function () {
    var finalAttributes = {};
    if (href) {
      finalAttributes = _objectSpread(_objectSpread({}, extraLinkAttributes), {}, {
        href: href
      });
    }
    return finalAttributes;
  }, [href, extraLinkAttributes]);
  var handleClick = function handleClick() {
    onClick(options);
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cn('option', {
      'option--active': active,
      'option--link': href
    }),
    onClick: handleClick
  }, linkAttributes, {
    type: href ? undefined : 'button',
    "data-t-id": "components-DropdownOption"
  }), /*#__PURE__*/React.createElement(OptionContent, {
    active: active,
    activeOptions: options,
    additionalInfo: additionalInfo,
    cardNumber: cardNumber,
    color: color,
    iconSrc: iconSrc,
    label: label,
    "data-t-id": "components-DropdownOption"
  }));
});